// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__29E-C","boxTitle":"Qualiphy_boxTitle__3hwbA","box":"Qualiphy_box__2rc_f","toggleWrap":"Qualiphy_toggleWrap__2DTa-"};